import { Box, getThemeSpacing } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Container = styled(Box)`
  flex: 1;
  flex-wrap: wrap;
  gap: ${({ theme }) => getThemeSpacing(8, theme)};
  row-gap: ${({ theme }) => getThemeSpacing(1, theme)};
`
